import axios from '@/libs/api.request'

const Api = {
  SSO: '/member/wechat',
  Info: '/member/info',
  RegCode: '/member/reg/code',
  Reg: '/member/reg',
  Auth: '/member/auth',
  RegConfirm: '/member/reg/confirm'
}

export const getSSO = (token) => {
  return axios.request({
    url: Api.SSO,
    data: {
      token
    },
    method: 'post'
  })
}

export const getUserInfo = () => {
  return axios.request({
    url: Api.Info,
    method: 'get'
  })
}

export const updateUserInfo = (data) => {
  return axios.request({
    url: Api.Info,
    data: data,
    method: 'put'
  })
}

export const getRegCode = (key) => {
  return axios.request({
    url: Api.RegCode + '?key=' + key,
    method: 'get'
  })
}

export const userReg = (data) => {
  return axios.request({
    url: Api.Reg,
    data: data,
    method: 'post'
  })
}

export const confirmUser = (data) => {
  return axios.request({
    url: Api.RegConfirm,
    data: data,
    method: 'post'
  })
}

export const authUser = (data) => {
  return axios.request({
    url: Api.Auth,
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js